import { MatDatepickerIntl } from '@angular/material/datepicker';

export function getPolishDatepickerIntl(): MatDatepickerIntl {
	const datepickerIntl = new MatDatepickerIntl();

	datepickerIntl.calendarLabel = 'Kalendarz';
	datepickerIntl.openCalendarLabel = 'Otwórz kalendarz';
	datepickerIntl.closeCalendarLabel = 'Zamknij kalendarz';
	datepickerIntl.prevMonthLabel = 'Poprzedni miesiąc';
	datepickerIntl.nextMonthLabel = 'Następny miesiąc';
	datepickerIntl.prevYearLabel = 'Poprzedni rok';
	datepickerIntl.nextYearLabel = 'Następny rok';
	datepickerIntl.prevMultiYearLabel = 'Poprzednie 24 lata';
	datepickerIntl.nextMultiYearLabel = 'Następne 24 lata';
	datepickerIntl.switchToMonthViewLabel = 'Wybierz datę';
	datepickerIntl.switchToMultiYearViewLabel = 'Wybierz miesiąc i rok';
	datepickerIntl.startDateLabel = 'Data początkowa';
	datepickerIntl.endDateLabel = 'Data końcowa';
	datepickerIntl.formatYearRangeLabel = (start: string, end: string) => `od ${start} do ${end}`;

	return datepickerIntl;
}
